/*
 * Copyright (C) 2026 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { Injectable } from '@angular/core';
import { NestedPathHelper } from '@app/app/shared/helpers/nested-path.helper';
import { Organization } from '@app/app/shared/models';

@Injectable({ providedIn: 'root' })
export class ShareUrlService {
  buildOrganizationEntityUrl(organization: Pick<Organization, 'domain'>, currentUrl: string, fallbackPath: string): string {
    const entityPath = NestedPathHelper.parsePath(currentUrl)?.fullPath ?? fallbackPath;

    return this.buildOrganizationUrl(organization, entityPath);
  }

  buildOrganizationUrl(organization: Pick<Organization, 'domain'>, path: string): string {
    const domain = organization.domain
      .trim()
      .replace(/^https?:\/\//i, '')
      .replace(/\/+$/, '');
    const normalizedPath = path.replace(/^\/+/, '');

    return `https://${domain}/${normalizedPath}`;
  }
}
